import { ImageButton } from '../button/image.button';
import { Icon } from '../icon';
import { MaterialIcon } from '../icon/icons';
import { addStyles } from '../theme';
import { m, type MithrilVNode } from '../../mithril';
import { CSS, Style } from './search.input.style';

addStyles(Style);

export { CSS } from './search.input.style';

export interface SearchInputAttrs {
	value: string;
	placeholder: string;
	onValue: (next: string) => void;
	className?: string;
}

/**
 * Controlled search bar — props in, events out; the caller owns the value.
 */
export const SearchInput = {
	view(attrs: SearchInputAttrs): MithrilVNode {
		return m('div', { className: attrs.className != null ? `${CSS.container} ${attrs.className}` : CSS.container }, [
			Icon.view(MaterialIcon.SEARCH, { className: CSS.icon }),
			m('input', {
				className: CSS.input,
				type: 'text',
				placeholder: attrs.placeholder,
				value: attrs.value,
				oninput: (e: Event) => {
					const target = e.target;
					if (target != null && 'value' in target && typeof target.value === 'string') {
						attrs.onValue(target.value);
					}
				},
			}),
			attrs.value !== ''
				? ImageButton.view(MaterialIcon.CLOSE, { className: CSS.clear, onclick: () => attrs.onValue('') })
				: null,
		]);
	},
};
